"use client";

import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  previousDaysUndeposited: [],
  todaysDeposit: [],
  totalTodaysDeposit: 0,
};

const depositSlice = createSlice({
  name: "deposit",
  initialState,
  reducers: {
    setPreviousDaysUndeposited(state, action) {
      const deposit = state.previousDaysUndeposited.find(
        (d) => d.depositId === action.payload.depositId
      );
      if (deposit) {
        deposit.amountToDeposit = action.payload.amountToDeposit;
      } else {
        state.previousDaysUndeposited.push(action.payload);
      }
    },
    setTodaysShiftDeposit(state, action) {
      const deposit = state.todaysDeposit.find(
        (d) => d.depositId === action.payload.depositId
      );

      if (deposit) {
        deposit.amountToDeposit = action.payload.amountToDeposit;
        deposit.depositType = action.payload.depositType;
      } else {
        state.todaysDeposit.push(action.payload);
      }
    },

    resetDepositState(state, action) {
      return initialState;
    },

    resetTodaysDeposit(state, action) {
      state.todaysDeposit = [];
    },
  },
});

export const {
  setPreviousDaysUndeposited,
  setTodaysShiftDeposit,
  resetDepositState,
  resetTodaysDeposit,
} = depositSlice.actions;

export default depositSlice.reducer;
